import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import NoticeCreate from './NoticeCreate';
import NoticeList from './NoticeList';
import NoticeDetail from './NoticeDetail';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { useMembership } from '../../context/MembershipContext';
import {
  canCreateContentForTenant,
  isTenantAdminForTenant,
} from '../../platform/membershipPermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import useBrowserBackStack from '../../hooks/useBrowserBackStack';
import './Notices.css';

function Notices() {
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [showCreateNotice, setShowCreateNotice] = useState(false);
  const [noticeToEdit, setNoticeToEdit] = useState(null); // State for editing notice

  const { user } = useUser();
  const { tenantId } = useTenant();
  const { memberships } = useMembership();

  const handleSelectNotice = (notice) => {
    setSelectedNotice(notice);
    setShowCreateNotice(false);
    setNoticeToEdit(null); // Clear the edit state when selecting a notice
  };

  const resetToList = useCallback(() => {
    setSelectedNotice(null);
    setShowCreateNotice(false);
    setNoticeToEdit(null);
  }, []);

  const onList = !selectedNotice && !showCreateNotice;
  const closeDetailView = useBrowserBackStack(!onList, resetToList);

  const toggleCreateNoticeForm = () => {
    if (showCreateNotice) {
      closeDetailView();
      return;
    }
    setShowCreateNotice(true);
    setSelectedNotice(null);
    setNoticeToEdit(null);
  };

  const handleNoticeCreated = () => {
    setShowCreateNotice(false);
    setSelectedNotice(null);
    setNoticeToEdit(null); // Clear the edit state after creating a notice
  };

  const handleEditNotice = (notice) => {
    setNoticeToEdit(notice); // Set the notice to be edited
    setShowCreateNotice(true); // Show the notice create form in edit mode
    setSelectedNotice(null);
  };

  const headerTitle = selectedNotice?.title || noticeToEdit?.title
    || (showCreateNotice ? 'Ustvari obvestilo' : 'Obvestila');

  return (
    <div className="platform-module-container notices-container">
        <ModulePageHeader
          eyebrow={!onList ? 'Obvestila' : undefined}
          title={headerTitle}
          subtitle={onList ? 'Pomembna obvestila in novice sindikata.' : undefined}
          actions={(
            <>
              {!selectedNotice && canCreateContentForTenant(memberships, tenantId, user) && (
                <Button variant="primary" onClick={toggleCreateNoticeForm}>
                  {showCreateNotice ? 'Nazaj na obvestila' : 'Ustvari obvestilo'}
                </Button>
              )}
              {selectedNotice && (
                <Button variant="primary" onClick={closeDetailView}>Nazaj na obvestila</Button>
              )}
            </>
          )}
        />
        {!selectedNotice ? (
          <>
            {showCreateNotice ? (
              <NoticeCreate onNoticeCreated={handleNoticeCreated} noticeToEdit={noticeToEdit} />
            ) : (
              <NoticeList
                onSelectNotice={handleSelectNotice}
                isAdmin={isTenantAdminForTenant(memberships, tenantId, user)}
                onEditNotice={handleEditNotice} // Pass the edit handler to the list
              />
            )}
          </>
        ) : (
          <NoticeDetail notice={selectedNotice} />
        )}
    </div>
  );
}

export default Notices;
